<div>
    <app-icon ic="IcEditPen" size="s" color="var(--color-primary-60)" (click)="editBtnAction()"></app-icon>
    <app-icon *ngIf="subType" ic="IcList" size="s" color="var(--color-primary-60)" (click)="listBtnAction()"></app-icon>
</div>
